/* Converted to vanilla JS */
document.addEventListener('DOMContentLoaded', function () {
    var offset = 50;
    var currentiFrameHeight = 0;

    var hotelSelects = document.querySelectorAll('.hotel-form-select');
    hotelSelects.forEach(function (sel) {
        sel.addEventListener('change', function () {
            if (!sel.value) {
                document.querySelectorAll('.hotel-form-wrapper').forEach(function (w) { w.classList.remove('active'); });
            } else {
                document.querySelectorAll('.hotel-form-wrapper').forEach(function (w) { w.classList.remove('active'); });
                var selectedWrapper = document.querySelector('.hotel-form-wrapper[data-hotelidx="' + sel.value + '"]');
                if (selectedWrapper) selectedWrapper.classList.add('active');

                var iframe = selectedWrapper ? selectedWrapper.querySelector('.scsiFrame') : null;
                if (iframe) {
                    try {
                        var doc = iframe.contentWindow.document;
                        var rc = doc.getElementById('rc-portal');
                        if (rc) {
                            var thisiFrameHeight = rc.offsetHeight + offset;
                            selectedWrapper.style.height = thisiFrameHeight + 'px';
                        }
                    } catch (e) { }
                }
            }
        });
    });

    window.addEventListener('resize', function () {
        //resizeIFrame();
    });

    setInterval(function () { resizeIFrame(); }, 250);

    document.querySelectorAll("a[href^='#rfpFormSelector']").forEach(function (a) {
        a.addEventListener('click', function (e) {
            var fullHref = a.getAttribute('href');
            var parts = fullHref.split(/[-]+/);
            var hotelId = parts.pop();
            if (hotelId) {
                var select = document.getElementById('hotelFormSelect');
                if (select) {
                    select.value = hotelId;
                    select.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }
            var target = document.getElementById('rfpFormSelector');
            if (target) {
                var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
                window.scrollTo({ top: top, behavior: 'smooth' });
            }
            e.preventDefault();
        });
    });

    function resizeIFrame() {
        var activeWrapper = document.querySelector('.hotel-form-wrapper.active');
        if (!activeWrapper) return;
        var activeiFrame = activeWrapper.querySelector('.scsiFrame');
        if (activeiFrame) {
            try {
                var thisiFrameHeight = activeiFrame.contentWindow.document.getElementById('rc-portal').offsetHeight + offset;
                activeWrapper.style.height = thisiFrameHeight + 'px';

                if (thisiFrameHeight < currentiFrameHeight && (currentiFrameHeight - thisiFrameHeight) > 250) {
                    var target = document.getElementById('rfpFormSelector');
                    if (target) {
                        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
                        window.scrollTo({ top: top, behavior: 'smooth' });
                    }
                }
                currentiFrameHeight = thisiFrameHeight;
            } catch (e) { }
        }
    }
});
